@if (max_start_date && selected.length) {
  <span class="portfolio-start-text" [hidden]="hideStartDateText">
    Earliest possible start date:
    <span class="font-weight-bold">{{ max_start_date }}</span>
  </span>
}

<div class="np-tab-bar">
  <div class="seg">
    <button
      type="button"
      [class.active]="currentTab === 0"
      [disabled]="loading"
      (click)="setTab(0)"
    >
      Equity
    </button>
    <button
      type="button"
      [class.active]="currentTab === 1"
      [disabled]="loading"
      (click)="setTab(1)"
    >
      Fund
    </button>
    <button
      type="button"
      [class.active]="currentTab === 2"
      [disabled]="loading"
      (click)="setTab(2)"
    >
      ETF
    </button>
    <button
      type="button"
      [class.active]="currentTab === 3"
      [disabled]="loading"
      (click)="setTab(3)"
    >
      Portfolios
    </button>
    <button
      type="button"
      [class.active]="currentTab === 4"
      [disabled]="loading || !selected.length"
      (click)="setTab(4)"
    >
      Overview
    </button>
  </div>
  @if (currentTab < 3) {
    <div class="search">
      <app-new-portfolio-search
        [model]="currentFilters.searchTerm"
        (fetchCompanies)="onFetchCompanies()"
        (modelChange)="currentFilters.searchTerm = $event"
        [meta]="meta"
      >
      </app-new-portfolio-search>
      <button mat-icon-button (click)="toggle()" color="primary" class="filter-toggle-btn">
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
  }
</div>

<div class="filters-sidenav-content">
  @if (currentTab === 0) {
    <app-new-portfolio-active-sorting
      [selected]="selected"
      [selectedFilterLabels]="selectedFilterLabels"
      [filter_label_length_limit]="filter_label_length_limit"
      [currentFilters]="currentFilters"
      [sorting]="sorting"
      [checked]="checkedOnly"
      [onCheckChange]="onCheckChange"
      (selectAllClick)="onSelectAllCompany($event)"
      (deleteFilterClick)="onDeleteFilterClick($event)"
      (deleteDynamicFilterClick)="onDeleteDynamicFilterClick($event)"
      (deleteSortClick)="onDeleteSortClick($event)"
    ></app-new-portfolio-active-sorting>

    <div class="mat-elevation-z8 mt-4 pb-1">
      <div class="card mt-4 mb-4">
        <div class="card-body p-0" style="overflow: hidden">
          @if (assetType == "stock") {
            <app-asset-table
              [list]="mergedItems"
              [columnVisibility]="columnVisibility"
              [filterLists]="filterLists"
              [sorting]="sorting"
              [currentFilters]="currentFilters"
              [quantList]="dynamicColumns"
              filterProp="quant"
              (itemSelect)="onSelect($event)"
              (fetchCompanies)="onFetchCompanies()"
              (sortClicked)="onSortClick($event)"
            ></app-asset-table>
          }
        </div>
        @if (list.length) {
          <app-pagination
            [meta]="meta"
            (pageEvent)="onPageEvent($event)"
          ></app-pagination>
        }
      </div>
    </div>
  }

  @if (currentTab === 1) {
    <app-new-portfolio-active-sorting
      [selected]="selected"
      [selectedFilterLabels]="selectedFilterLabels"
      [filter_label_length_limit]="filter_label_length_limit"
      [currentFilters]="currentFilters"
      [sorting]="sorting"
      [checked]="checkedOnly"
      [onCheckChange]="onCheckChange"
      (selectAllClick)="onSelectAllCompany($event)"
      (deleteFilterClick)="onDeleteFilterClick($event)"
      (deleteDynamicFilterClick)="onDeleteDynamicFilterClick($event)"
      (deleteSortClick)="onDeleteSortClick($event)"
    ></app-new-portfolio-active-sorting>

    <div class="mat-elevation-z8 mt-4 pb-1">
      <div class="card mt-4 mb-4">
        <div class="card-body p-0" style="overflow: hidden">
          @if (assetType == "fund") {
            <app-asset-table
              [list]="mergedItems"
              [columnVisibility]="columnVisibility"
              [filterLists]="filterLists"
              [sorting]="sorting"
              [currentFilters]="currentFilters"
              [quantList]="dynamicColumns"
              filterProp="fund_reference_table"
              (itemSelect)="onSelect($event)"
              (fetchCompanies)="onFetchCompanies()"
              (sortClicked)="onSortClick($event)"
            ></app-asset-table>
          }
        </div>
        @if (list.length) {
          <app-pagination
            [meta]="meta"
            (pageEvent)="onPageEvent($event)"
          ></app-pagination>
        }
      </div>
    </div>
  }

  @if (currentTab === 2) {
    <app-new-portfolio-active-sorting
      [selected]="selected"
      [selectedFilterLabels]="selectedFilterLabels"
      [filter_label_length_limit]="filter_label_length_limit"
      [currentFilters]="currentFilters"
      [sorting]="sorting"
      [checked]="checkedOnly"
      [onCheckChange]="onCheckChange"
      (selectAllClick)="onSelectAllCompany($event)"
      (deleteFilterClick)="onDeleteFilterClick($event)"
      (deleteDynamicFilterClick)="onDeleteDynamicFilterClick($event)"
      (deleteSortClick)="onDeleteSortClick($event)"
    ></app-new-portfolio-active-sorting>
    <div class="mat-elevation-z8 mt-4 pb-1">
      <div class="card mb-4">
        <div class="card-body p-0 overflow-hidden">
          <div class="row">
            <div class="col-md-3">
              <app-sidebar-filter
                [currentFilters]="currentFilters"
                [filterLists]="filterLists"
                (onFilterEvent)="onFetchCompanies()"
                (onResetFilterEvent)="resetFilters()"
              ></app-sidebar-filter>
            </div>
            <div class="col-md-9">
              @if (assetType == "etf") {
                <app-asset-table
                  [list]="mergedItems"
                  [columnVisibility]="columnVisibility"
                  [filterLists]="filterLists"
                  [sorting]="sorting"
                  [currentFilters]="currentFilters"
                  [quantList]="dynamicColumns"
                  filterProp="etf_reference_table"
                  [widerFirstCol]="true"
                  (itemSelect)="onSelect($event)"
                  (fetchCompanies)="onFetchCompanies()"
                  (sortClicked)="onSortClick($event)"
                ></app-asset-table>
              }
            </div>
          </div>
        </div>
        @if (list.length) {
          <app-pagination
            [meta]="meta"
            (pageEvent)="onPageEvent($event)"
          ></app-pagination>
        }
      </div>
    </div>
  }

  @if (currentTab === 3) {
    <div class="mat-elevation-z8 mt-4 pb-1">
      <div class="card mt-4 mb-4">
        <div class="card-body p-0" style="overflow: hidden">
          @if (assetType == "portfolio") {
            <app-portfolio-selection-table
              [list]="portfolioList"
              [selectedIds]="selectedPortfolioIds"
              (portfolioSelect)="onPortfolioSelect($event)"
            ></app-portfolio-selection-table>
          }
        </div>
      </div>
    </div>
  }

  @if (currentTab === 4) {
    <div>
      <app-new-portfolio-select-dialog
        [portfolio]="portfolio"
        [list]="selected"
        (itemRemove)="onSelect($event)"
      ></app-new-portfolio-select-dialog>
    </div>
  }
</div>
